import langEn from "./en-US.json"
import langRu from "./ru-RU.json"

export const resources = { ru: { translation: langRu }, en: { translation: langEn } }
